import type { Palette } from "@/components/marketplace/palette"

// Theme tokens a payload may reference, mapped to the finite palette set
// (see src/styles/palette.css). Unknown or null themes fall back to brand.
const THEME_PALETTES: Record<string, Palette> = {
  "mothers-day": "pink",
  belleza: "pink",
  "hot-sale": "ember",
  electronics: "ocean",
  perfumes: "gold",
  shoes: "slate",
}

export const paletteForTheme = (theme: string | null): Palette | undefined => (theme ? THEME_PALETTES[theme] : undefined)

export const KNOWN_THEMES = Object.keys(THEME_PALETTES)

// Leaf categories have no authored feed page (so no `theme`), yet they should
// still read as the same color world as their merchandised surfaces. The chrome
// (drawer, search) needs the same handle→palette mapping plus a glyph, so both
// live in one place — this re-exports the palette half.
export { paletteForCategoryHandle } from "@/components/marketplace/category-visual"
